import { render, staticRenderFns } from "./UserProfileCardAnother.vue?vue&type=template&id=f8622b04&scoped=true&"
import script from "./UserProfileCardAnother.vue?vue&type=script&lang=js&"
export * from "./UserProfileCardAnother.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileCardAnother.vue?vue&type=style&index=0&id=f8622b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8622b04",
  null
  
)

export default component.exports